/* THRESHOLD GENERATION */
export const FETCH_THRESHOLD_STATUS = 'FETCH_THRESHOLD_STATUS';
export const FETCH_THRESHOLD_STATUS_SUCCESS = 'FETCH_THRESHOLD_STATUS_SUCCESS';
export const FETCH_THRESHOLD_STATUS_FAIL = 'FETCH_THRESHOLD_STATUS_FAIL';

export const TRIGGER_THRESHOLD_GENERATION = 'TRIGGER_THRESHOLD_GENERATION';
export const TRIGGER_THRESHOLD_GENERATION_SUCCESS =
  'TRIGGER_THRESHOLD_GENERATION_SUCCESS';
export const TRIGGER_THRESHOLD_GENERATION_FAIL =
  'TRIGGER_THRESHOLD_GENERATION_FAIL';

export const DISCARD_THRESHOLD_GENERATION = 'DISCARD_THRESHOLD_GENERATION';
export const DISCARD_THRESHOLD_GENERATION_SUCCESS =
  'DISCARD_THRESHOLD_GENERATION_SUCCESS';
export const DISCARD_THRESHOLD_GENERATION_FAIL =
  'DISCARD_THRESHOLD_GENERATION_FAIL';

export const FETCH_THRESHOLD_RESULTS = 'FETCH_THRESHOLD_RESULTS';
export const FETCH_THRESHOLD_RESULTS_SUCCESS =
  'FETCH_THRESHOLD_RESULTS_SUCCESS';
export const FETCH_THRESHOLD_RESULTS_FAIL = 'FETCH_THRESHOLD_RESULTS_FAIL';

export const FETCH_THRESHOLD_CONFIG = 'FETCH_THRESHOLD_CONFIG';
export const FETCH_THRESHOLD_CONFIG_SUCCESS = 'FETCH_THRESHOLD_CONFIG_SUCCESS';

export const THRESHOLD_GENERATION_RESET = 'THRESHOLD_GENERATION_RESET';

export function fetchThresholdStatus(payload) {
  return {
    type: FETCH_THRESHOLD_STATUS,
    payload
  };
}

export function fetchThresholdStatusSuccess(payload) {
  return {
    type: FETCH_THRESHOLD_STATUS_SUCCESS,
    payload
  };
}

export function fetchThresholdStatusFail(payload) {
  return {
    type: FETCH_THRESHOLD_STATUS_FAIL,
    payload
  };
}

export function triggerThresholdGeneration(payload) {
  return {
    type: TRIGGER_THRESHOLD_GENERATION,
    payload
  };
}

export function triggerThresholdGenerationSuccess(payload) {
  return {
    type: TRIGGER_THRESHOLD_GENERATION_SUCCESS,
    payload
  };
}

export function triggerThresholdGenerationFail(payload) {
  return {
    type: TRIGGER_THRESHOLD_GENERATION_FAIL,
    payload
  };
}

export function discardThresholdGeneration(payload) {
  return {
    type: DISCARD_THRESHOLD_GENERATION,
    payload
  };
}

export function discardThresholdGenerationSuccess(payload) {
  return {
    type: DISCARD_THRESHOLD_GENERATION_SUCCESS,
    payload
  };
}

export function discardThresholdGenerationFail(payload) {
  return {
    type: DISCARD_THRESHOLD_GENERATION_FAIL,
    payload
  };
}

export function fetchThresholdResults(payload) {
  return {
    type: FETCH_THRESHOLD_RESULTS,
    payload
  };
}

export function fetchThresholdResultsSuccess(payload) {
  return {
    type: FETCH_THRESHOLD_RESULTS_SUCCESS,
    payload
  };
}

export function fetchThresholdResultsFail(payload) {
  return {
    type: FETCH_THRESHOLD_RESULTS_FAIL,
    payload
  };
}

export function fetchThresholdConfig(payload) {
  return {
    type: FETCH_THRESHOLD_CONFIG,
    payload
  };
}

export function fetchThresholdConfigSuccess(payload) {
  return {
    type: FETCH_THRESHOLD_CONFIG_SUCCESS,
    payload
  };
}

export function thresholdGenerationReset() {
  return {
    type: THRESHOLD_GENERATION_RESET
  };
}
